import { render, staticRenderFns } from "./customer-orders-list.vue?vue&type=template&id=cfbd2cd4&scoped=true"
import script from "./customer-orders-list.vue?vue&type=script&lang=js"
export * from "./customer-orders-list.vue?vue&type=script&lang=js"
import style0 from "./customer-orders-list.vue?vue&type=style&index=0&id=cfbd2cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbd2cd4",
  null
  
)

export default component.exports